import {
  AssignmentOption,
  GroupByOption,
} from 'src/pages/operators/assignments/overview/types';
import * as pp from 'src/utils/page-params';

export function assertAssignmentOption(
  value: string
): asserts value is AssignmentOption {
  if (value === 'own' || value === 'all') {
    type TypeCheck<T extends AssignmentOption = typeof value> = T;
  } else {
    throw new Error(`${value} is not of type "AssignmentOption".`);
  }
}

export function assertGroupByOption(
  value: string
): asserts value is GroupByOption {
  if (value === 'operator' || value === 'user') {
    type TypeCheck<T extends GroupByOption = typeof value> = T;
  } else {
    throw new Error(`${value} is not of type "GroupByOption".`);
  }
}

export function useAssignmentsOverviewParams() {
  return pp.usePageParams(
    pp
      .configure()
      .add(
        pp
          .param('assignments')
          .default<AssignmentOption>('own')
          .filter({ label: 'Assignments' })
      )
      .add(
        pp
          .param('groupBy')
          .default<GroupByOption>('operator')
          .filter({ label: 'Group by' })
      )
  );
}

export type AssignmentOverviewParams = ReturnType<
  typeof useAssignmentsOverviewParams
>;
